import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import Feed from './components/Feed';
import MyList from './components/MyList';
import Search from './components/Search';
import MyProfile from './components/MyProfile';
import Login from './components/Login';
import MovieDetails from './components/MovieDetails';
import PublicMovieDetails from './components/PublicMovieDetails';
import BottomNavBar from './components/BottomNavBar';
import MyReco from './components/MyReco';
import Register from './components/Register';
import UserProfile from './components/UserProfile';
import PublicUserProfile from './components/PublicUserProfile';
import CompatInvite from './components/CompatInvite';
import PublicQuizDetails from './components/PublicQuizDetails';
import TinderSwap from './components/TinderSwap';
import Home from './components/Home';
import AppLanding from './components/AppLanding';
import MyProfileFriends from './components/MyProfileFriends';
import MyFilmotheque from './components/MyFilmotheque';
import Support from './components/Support';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import './App.css';


function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <div className="App">
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<AppLanding />} />
            <Route path="/social" element={<Feed />} />
            <Route path="/my-list" element={<MyList />} />
            <Route path="/search" element={<Search />} />
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/my-profile-friends" element={<MyProfileFriends />} />
            <Route path="/:media_type/:film_id" element={<PublicMovieDetails />} />
            <Route path="/recommendations" element={<MyReco />} />
            <Route path="/user/:userId" element={<PublicUserProfile />} />
            <Route path="/compat-invite/:inviterId" element={<CompatInvite />} />
            <Route path="/quiz/:quizId" element={<PublicQuizDetails />} />
            <Route path="/tinder" element={<TinderSwap />} />
            <Route path="/my-filmotheque" element={<MyFilmotheque />} />
            <Route path="/support" element={<Support />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
          <BottomNavBarWrapper />

          </div>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

// Composant wrapper pour BottomNavBar - masqué sur toutes les pages
const BottomNavBarWrapper = () => {
  return null;
};

export default App;
